import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["data-hidden-assemblies"];
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "scrollbar-flex-content"
};
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import ProductAssembly from "./ProductAssembly.vue";
import { useConfiguratorStore } from "@/stores/configuratorData";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import { isProductAssembly } from "@/utils/responseUtil";
export default /*@__PURE__*/_defineComponent({
  __name: 'productProducts',
  props: ["currentState", "refLeftContent", "refRightContent"],
  setup(__props) {
    const props = __props;
    const {
      eventBus
    } = getCurrentInstance()?.appContext.config.globalProperties ?? {
      eventBus: undefined
    };
    const configuratorStore = useConfiguratorStore();
    const attribute = useAdditionalAttrStore();
    const currentCoding = computed(() => configuratorStore.apiConfiguratorResult?.ConfiguratorResult.CurrentState.CurrentCoding?.filter(item => isProductAssembly(item) && (item.Optional !== "Yes" || configuratorStore.selectedAssemblies.map(assembly => assembly.codeTypeId).includes(item.CodeTypeId))));
    const isFullScreen = ref(false);
    const scrollbarRef = ref();
    const scrollbarClass = ref("");
    const handleScroll = e => {
      let eWheelDelta;
      if ("wheelDelta" in e && typeof e.wheelDelta === "number") {
        eWheelDelta = e.wheelDelta;
      }
      const wheelDelta = eWheelDelta || -e.deltaY * 33;
      scrollbarRef.value.setScrollLeft(scrollbarRef.value.wrapRef.scrollLeft - wheelDelta);
      if (scrollbarRef.value.wrapRef.scrollLeft === 0) {
        scrollbarClass.value = "";
      } else {
        scrollbarClass.value = "scrolled";
      }
    };
    const isScrolled = ref(false);
    window.addEventListener("scroll", e => {
      const ele = e.target.classList?.contains("el-dialog");
      if (ele) {
        const scrollElement = e.target.scrollTop;
        if (scrollElement > 50) {
          isScrolled.value = true;
        } else {
          isScrolled.value = false;
        }
      }
    }, true);
    const winWidth = ref(0);
    const maxContainerNumber = ref(window.innerWidth - props.refRightContent.offsetWidth);
    const leftContentWidth = ref();
    const maxContainerWidth = ref(maxContainerNumber.value + "px !important");
    const getWindowResize = () => {
      winWidth.value = window.innerWidth;
      if (winWidth.value > 991) {
        if (props.refRightContent.offsetWidth > 0) {
          maxContainerNumber.value = window.innerWidth - props.refRightContent.offsetWidth;
          maxContainerWidth.value = maxContainerNumber.value + "px !important";
        }
      } else {
        maxContainerWidth.value = "";
      }
      leftContentWidth.value = props.refLeftContent.offsetWidth;
    };
    // const getStyle = computed(() => {
    //   if (isFullScreen.value === false) {
    //     return {
    //       maxWidth: maxContainerWidth.value,
    //     };
    //   } else {
    //     return {};
    //   }
    // });
    const getMarginLeft = computed(() => {
      const leftStyle = window.getComputedStyle(props.refLeftContent);
      if (winWidth.value > 991 && leftContentWidth.value) {
        if (isFullScreen.value) {
          if (winWidth.value > leftContentWidth.value) {
            return (winWidth.value - leftContentWidth.value) / 2;
          }
        } else {
          if (maxContainerNumber.value > leftContentWidth.value) {
            let lessSpace = 0;
            const isChrome = navigator.userAgent.indexOf("Chrome") > -1;
            if (isChrome) {
              lessSpace = 10;
            }
            return maxContainerNumber.value - leftContentWidth.value - parseInt(leftStyle.marginRight.replace("px", "")) - lessSpace;
          }
        }
      }
      return 0;
    });
    let setFullInternal = 0;
    eventBus.on("setFullContainer", status => {
      if (status !== false) {
        if (status === "full") {
          isFullScreen.value = true;
        }
        if (status === "half") {
          isFullScreen.value = false;
        }
        clearTimeout(setFullInternal);
        setFullInternal = setTimeout(() => {
          getWindowResize();
        }, 600);
        eventBus.emit("setFullContainer", false);
      }
    });
    onMounted(() => {
      let winSizeInternal = 0,
        winResizeInternal = 0;
      window.addEventListener("resize", () => {
        clearTimeout(winResizeInternal);
        winResizeInternal = setTimeout(getWindowResize, 500);
      });
      setTimeout(() => {
        getWindowResize();
      }, 1000);
      window.addEventListener("keydown", e => {
        if (e.key === "F12" || e.key === "f12") {
          clearTimeout(winSizeInternal);
          winSizeInternal = setTimeout(() => getWindowResize, 500);
        }
      });
    });
    return (_ctx, _cache) => {
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return __props.currentState && (currentCoding.value?.length ?? 0) > 1 && _unref(attribute).getDataConfig.hideAssemblies !== true ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['product-products', isScrolled.value ? 'scrolling' : '']),
        "data-hidden-assemblies": _unref(attribute).getDataConfig.hideAssemblies
      }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_scrollbar, {
        ref_key: "scrollbarRef",
        ref: scrollbarRef,
        onWheel: _withModifiers(handleScroll, ["prevent"]),
        class: _normalizeClass(scrollbarClass.value)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentCoding.value, (currentCodingItem, key) => {
          return _openBlock(), _createBlock(ProductAssembly, {
            key: currentCodingItem.CodeTypeId,
            currentCodingItem: currentCodingItem,
            marginLeft: getMarginLeft.value,
            currentIndex: key
          }, null, 8, ["currentCodingItem", "marginLeft", "currentIndex"]);
        }), 128)), _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "assmebly-spacer"
        }, null, -1))])]),
        _: 1
      }, 8, ["class"])])], 10, _hoisted_1)) : _createCommentVNode("", true);
    };
  }
});